import React, { useContext, useMemo } from 'react';
import { Icon, IconButton, Box, Link } from '@chakra-ui/react';
import { Link as GatsbyLink } from 'gatsby';
import { createModuleFromDefs, StarberryComponentContext, $$, $ } from '@starberry/components';
import { Routes } from '../../routes';

const DeleteIcon = () => {
  const { constants } = useContext(StarberryComponentContext);

  return <Icon as={constants.icons.savePropertyDelete} boxSize={[4, null, 6]} />;
};

const PropertyItemComponent = ({ content }) => {
  const context = useContext(StarberryComponentContext);
  const {
    constants,
    data: { slug, status, id },
  } = context;

  const url = useMemo(() => {
    if (constants.propertyPageDetails) {
      return `${Routes.MyPropertyPage}/buying/${id}`;
    }
    return `${constants['website-url']}/property-${status
      ?.toLowerCase()
      .split(' ')
      .join('-')}/${slug}-${id}`;
  }, [constants, slug, status, id]);

  const Children = createModuleFromDefs(context, content);
  if (!Children) {
    return null;
  }

  return (
    <Link as={GatsbyLink} href={url} _hover={{ textDecoration: 'none' }}>
      <Box>
        <Children />
      </Box>
    </Link>
  );
};
const PropertyItem = {
  component: PropertyItemComponent,
  addressProps: {},
  props: {
    content: ({ horizontal, onDelete, showRooms, showPrice, addressProps }) => {
      return {
        $: 'Stack',
        props: {
          spacing: 0,
          direction: horizontal ? 'row' : 'column',
        },
        children: [
          {
            $: 'Box',
            props: {
              position: 'relative',
            },
            children: [
              {
                $: 'MotionImage',
                backgroundImage: true,
                imgProps: {
                  pb: '66.5%',
                },
                src: $('images.0.srcUrl'),
                props: {
                  width: horizontal ? '90px' : '100%',
                  mr: horizontal ? 4 : 0,
                },
              },
              onDelete
                ? {
                    component: IconButton,
                    props: {
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      zIndex: 20,
                      icon: DeleteIcon,
                      bgColor: 'transparent',
                      color: '#fff',
                      onClick: onDelete,
                      _hover: {
                        bg: 'rgba(0,0,0,0.3)',
                      },
                    },
                  }
                : null,
            ],
          },
          {
            $: 'Stack',
            props: {
              spacing: 1,
              pt: horizontal ? 0 : [3, null, 6],
            },
            children: [
              {
                $: 'H3',
                props: {
                  fontSize: $$(
                    'constants.body.bodySize.medium',
                    null,
                    'constants.body.bodySize.large'
                  ),
                  lineHeight: $$(
                    'constants.body.bodyLineHeight.medium',
                    null,
                    'constants.body.bodyLineHeight.large'
                  ),
                  mb: 0.5,
                  ...addressProps,
                },
                children: $('display_address'),
              },
              {
                $: 'Stack',
                props: {
                  position: 'relative',
                  direction: horizontal ? 'column' : ['column', null, null, 'row'],
                  justifyContent: 'space-between',
                  spacing: 10,
                },
                children: [
                  horizontal
                    ? {
                        $: 'Stack',
                        props: {
                          spacing: 1,
                        },
                        children: [
                          showPrice && { $: 'CurrencyFormat', number: $('price') },
                          showRooms && {
                            $: 'PropertyRooms',
                            bedroom: $('bedroom'),
                            bathroom: $('bathroom'),
                          },
                        ],
                      }
                    : {
                        $: 'Stack',
                        props: {
                          spacing: 1,
                        },
                        children: [
                          showRooms && {
                            $: 'PropertyRooms',
                            bedroom: $('bedroom'),
                            bathroom: $('bathroom'),
                          },
                          showPrice && {
                            $: 'HStack',
                            props: {
                              spacing: 2,
                            },
                            children: [
                              { $: 'Text', children: 'Asking Price' },
                              { $: 'CurrencyFormat', number: $('price') },
                            ],
                          },
                        ],
                      },
                ],
              },
            ],
          },
        ],
      };
    },
  },
};

export default PropertyItem;
